import { Contract } from '@ethersproject/contracts'
import type { Signer } from '@ethersproject/abstract-signer'
import type { Provider } from '@ethersproject/providers'
import { AddressZero } from '@ethersproject/constants'

import { isAddress } from './address'
import { ContractAddressMap, FACTORY_ADDRESS, FARM_ADDRESS, VAULT_ADDRESS } from '@/constants/contract/contractAddress'
import FACTORY_ABI from '@/constants/contract/abis/factory.json'
import VAULT_ABI from '@/constants/contract/abis/vault.json'
import FARM_ABI from '@/constants/contract/abis/farm.json'
import { Factory, Farm, Vault } from '@/constants/contract/contractTypes'
import { ETHEREUM_CHAIN_ID } from '@/constants'
import { TICKERS_MAP_BY_NAME, SupportedTicker } from '@/constants/token'

export function getContract(address: string, ABI: any, signer?: Signer | Provider): Contract {
  if (!isAddress(address) || address === AddressZero) {
    throw Error(`Invalid 'address' parameter '${address}'.`)
  }

  return new Contract(address, ABI, signer)
}

const getContractAddress = (addressMap: ContractAddressMap, chainId?: number): `0x${string}` => {
  return addressMap?.[chainId] ?? addressMap?.[ETHEREUM_CHAIN_ID]
}

export const getFactoryContractAddress = (chainId?: number) => {
  return getContractAddress(FACTORY_ADDRESS, chainId)
}

export const getVaultContractAddress = (chainId?: number) => {
  return getContractAddress(VAULT_ADDRESS, chainId)
}

export const getFarmContractAddress = (chainId?: number) => {
  return getContractAddress(FARM_ADDRESS, chainId)
}

export const getBrc20ContractAddress = (tokenName: SupportedTicker, chainId?: number) => {
  return TICKERS_MAP_BY_NAME?.[tokenName]?.erc20Tokens?.[chainId]?.address
}

export const getFactoryContract = (signer?: Signer | Provider, chainId?: number) => {
  return getContract(getFactoryContractAddress(chainId), FACTORY_ABI, signer) as Factory
}

export const getVaultContract = (signer?: Signer | Provider, chainId?: number) => {
  return getContract(getVaultContractAddress(chainId), VAULT_ABI, signer) as Vault
}

export const getFarmContract = (signer?: Signer | Provider, chainId?: number) => {
  return getContract(getFarmContractAddress(chainId), FARM_ABI, signer) as Farm
}
